import Base from './base';
import Event from './event';

export default class Subordination extends Base {
  constructor(item, url) {
    super(item, url);

    this.main_event_id = item.main_event_id;
    this.organizer_id = item.organizer_id;

    this.status = item.status || null;
    this.event_id = item.event_id || null;
    this.exchange_id = item.exchange_id || null;

    // expand
    this.event = item.event ? new Event(item.event) : null;
    this.organizer = item.organizer || null;

    this.main_event = null;
    this.organization = item.organizer || null;
  }

  setOrganization(organizationResponseData) {
    this.organization = organizationResponseData;
  }

  setMainEvent(data = null) {
    this.main_event = data ? new Event(data) : null;
  }
}
